<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <div class="main-find">
       
            <!-- 是否匹配 -->

            <!-- <span >{{ $t("logs.topic_statistical") }}:</span> -->
            <el-select v-model="salt_minion_ip" placeholder="" style="width:12%;margin-right:10px"  @change="rule_combine" v-if="this.has_min==1">
                <el-option v-for="item in salt_minion_ipp" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
         
        </div>
        <el-tabs @tab-click="dianji">
            <!-- 规则匹配 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.topic_statistical") }}
                </span>

                <div class="switch1">
                    <div class="main">

                    </div>
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="SUBJECT" :label="$t('logs.topic_statistical_title')"></el-table-column>
                          
                            <el-table-column prop="NUMCN" :label="$t('logs.statRule1_a4')"></el-table-column>
                        
                        </el-table>
                    </div>
                  
                </div>
            </el-tab-pane>

        
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            loading: false,
            type: 2,
            typee: [],
            match: 1,
            matchh: [],
            salt_minion_ip: '127.0.0.1',
            salt_minion_ipp: [],
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44"
            }],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS"
                },
                {
                    value: "选项2",
                    label: "增加信头标记"
                },
                {
                    value: "选项3",
                    label: "强制TLS"
                }
            ],
            checked: "",
            fileList: [],
            radio: [],
            tab_num: '',
            CENTER_RULE_MATCH: '',
            has_min: ''
        };
    },
    mounted() {
        this.getFileList1()
    },
    methods: {
        rule_regex(a) {
            this.type = a
            this.getFileList1()
        },
        rule_combine(a) {
            this.salt_minion_ip = a
            this.getFileList1()
        },
        rule_new(a) {
            this.salt_minion_ip = a
            this.getFileList1()
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        dianji(a) {
            // console.log(a.index)
            this.tab_num = a.index
            this.getFileList1();
        },
        // 邮件数加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
           
            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "cmd_print_sub_audit",
                        sid: sid,

                        salt_minion_ip: this.salt_minion_ip,

                    },
                })
                .then((res) => {
                    console.log(res);

                  if(!res){
             this.loading = false;
          }
         else   if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList = res.data.ret.datalist;
                     
                        this.salt_minion_ipp = res.data.ret.q_minion_host;
                      

                      
                        if (res.data.ret.HAS_MINION) {
                            this.has_min = 1
                        }
                        
                    }

                })

        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        }
    }
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/email_manage.less";

.table01 {

    /deep/ .has-gutter th:nth-child(1) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(3) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(6) {
        text-align: center;

    }

    // 表格居中位置
    /deep/ .el-table__row td:nth-child(1) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(3) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(6) {
        text-align: center;

    }
}

.main-find {
    // width: 100%;
    height: 50px;
    padding-left: 14px;
    // padding-bottom: 5px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: left;

    border-bottom: 2px solid #D2D7E6;
    // background: #FFFFFF;

    span {
        margin-right: 8px;

        // width: 126px;
        // display: inline-block;
        color: #0E2C5E;
    }

    .el-input {
        margin-right: 8px;
        width: 20%;
        line-height: 32px;
        height: 32px;
        // padding: 5px 10px 5px 0;

    }

    // input 框高度
    /deep/ .el-input__inner {
        height: 32px;
        padding: 0 6px;
    }

    /deep/ .el-input--suffix {
        // width: 150px;
        margin-right: 10px;
    }

    /deep/ .el-button {
        margin-right: 10px;
        // margin-left: 30px;
    }
}

//  条件下 搜索 button  按钮
.main-find /deep/ .el-button {
    padding: 8px 10px;

    background: #006BE7;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;

}

.main_style_family {

    font-family: PingFangSC-Medium, PingFang SC;
    color: #0E2C5E;
    font-size: 14px;
}
</style>
